import { render, staticRenderFns } from "./heading-cmp.vue?vue&type=template&id=8539a112&scoped=true"
import script from "./heading-cmp.vue?vue&type=script&lang=js"
export * from "./heading-cmp.vue?vue&type=script&lang=js"
import style0 from "./heading-cmp.vue?vue&type=style&index=0&id=8539a112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8539a112",
  null
  
)

export default component.exports